export const HIGH_REVENUE_COUNTRY_CODES = ['us', 'de', 'ch', 'gb']
export const APAC_COUNTRY_CODES = ['hk', 'id', 'in', 'jp', 'kr', 'my', 'nz', 'ph', 'sg', 'th', 'tw']
export const checkForApacCountry = () => APAC_COUNTRY_CODES.includes(document.body.dataset.country)
export const IMPERIAL_SYSTEM_COUNTRY_CODES = ['us', 'gb']
export const IMPERIAL_SYSTEM = 'imperial_system'
export const METRIC_SYSTEM = 'metric_system'
